export default function () {
  this.loadMessage()
}
